<template>
  <!-- 有文字提示弹窗 -->
  <ll-tooltip
    v-if="isShowTooltip && isShow"
    v-bind="tooltipProps"
    :tip="tooltipTitle"
    :is-white-bg="props.isWhiteBg"
    :arrow="props.arrow"
    :class="tooltipClass"
  >
    <a-button
      ref="btn"
      type="text"
      :disabled="disabled"
      :class="`${btnClass}`"
      :style="style"
      @click="handleClickBtn"
    >
      <ll-icon v-if="iconName" :icon-name="iconName" />
      <span v-if="isShowTitle" :class="bem.e('text')">{{ tooltipTitle }}</span>
    </a-button>
  </ll-tooltip>
  <!-- 没有文字提示弹窗 -->
  <a-button
    v-else-if="!isShowTooltip && isShow"
    ref="btn"
    type="text"
    :disabled="disabled"
    :class="`${btnClass}`"
    :style="style"
    @click="handleClickBtn"
  >
    <ll-icon
      v-if="iconName"
      :icon-name="iconName"
      :class="bem.e('text-icon')"
    />
    <span v-if="isShowTitle" :class="bem.e('text')">{{ tooltipTitle }}</span>
  </a-button>
</template>

<script lang="ts" setup>
import { computed, ref } from 'vue'

import { createNamespace } from '@ll-plus/utils'
import { iconBaseProps } from './icon-base'

// 1.defineOptions
defineOptions({
  name: 'LlIconBase',
})

// 2.props
const props = defineProps(iconBaseProps)
// 3.computed/const
const btn = ref()
// button的类名样式
const btnClass = computed(() => {
  const isDefault = props.iconType === 'default' || !props.iconType
  // 1.类型的class
  const typeClass = isDefault ? bem.m('default') : bem.m('primary')
  // 2.是否要裸露的class
  const exposedClass = props.isShowContainer
    ? bem.m('container')
    : bem.m('exposed')
  // 3.有文本的class
  const hasTextClass = props.isShowTitle ? bem.m('has-text') : ''
  // 4.禁用的class
  const disabledClass = props.disabled
    ? isDefault
      ? bem.is('default-disable')
      : bem.is('primary-disable')
    : ''
  return `${
    props.class
  } ${bem.b()} ${typeClass} ${exposedClass} ${hasTextClass} ${disabledClass}`
})
const bem = createNamespace('icon-base')

// 4.methods
const handleClickBtn = (e: Event) => {
  props.onClick && props.onClick(e, props.data)
  btn.value?.blur()
}
</script>
